import { Context } from "../Reducers/Store";
import React, { useCallback, useState, useEffect, useContext } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import NavMenu from "../Components/NavMenu";
import Toasts from "../Components/Toasts";
import { useMediaQuery } from "react-responsive";
import Loading from "../Components/Loading";
import Sidebar from "../Components/Sidebar";
import Container from "react-bootstrap/Container";
import "./Logged/Styles/main.scss";
import { Row, Col, Button } from "react-bootstrap";
import ProfileCard from "../Components/ProfileCard/profile-card";

const Layout = (props) => {
  const [state, dispatch] = useContext(Context);
  const [expanded, setExpanded] = useState(false);
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });
  const location = useLocation();
  const [title, setTitle] = useState(null);

  const handleExpand = (exp) => {
    localStorage.setItem("sidebar", exp);
    setExpanded(exp);
  };

  useEffect(() => {
    setExpanded(localStorage.getItem("sidebar") == "true");

    if (location.pathname == "/account") setTitle("Account");
    else if (location.pathname == "/ondemandsettings") setTitle("On Demand Settings");
    else if (location.pathname == "/newEvent") setTitle("New Event");
    else if (location.pathname.indexOf("/manageEvent/") == 0)
      setTitle("Edit Event");
    else if (location.pathname.indexOf("/manageChannel/") == 0)
      setTitle("Edit Channel");
    else if (location.pathname.indexOf("/manageInput/") == 0)
      setTitle("Edit Input");
    else if (location.pathname == "/listingChannels")
      setTitle("Channels");
    else if (location.pathname == "/listingEvents") setTitle("Events");
    else if (location.pathname == "/listingInputs") setTitle("Inputs");
    else if (location.pathname == "/users") setTitle("Users");
    else if (location.pathname == "/newInput") setTitle("New Input");
    else if (location.pathname == "/addNewChannel") setTitle("Add New Channel");
    else if (location.pathname == "/users/new") setTitle("New User");
    else if (location.pathname.indexOf("/users/edit/") == 0)
      setTitle("Edit User");
    else if (location.pathname == "/videoArchive") setTitle("Video Archive");
    else if (location.pathname.indexOf("/videoArchive/edit/") == 0)
      setTitle("Edit Video Archive");
    else if (location.pathname == "/videoArchive/series") setTitle("Series");
    else if (location.pathname == "/videoArchive/series/new")
      setTitle("New Series");
    else if (location.pathname == "/videoArchive/series/general")
      setTitle("General Series");
    else if (location.pathname.indexOf("/videoArchive/series/edit/") == 0)
      setTitle("Edit Series");
    else setTitle(null);
  }, [location]);

  const navigate = useNavigate();

  function handleClick() {
    navigate(-1);
  }

  return (
    <div className="App">
      <Sidebar expanded={expanded} setExpanded={handleExpand} />
      <NavMenu
        style={{ paddingLeft: expanded ? (isTabletOrMobile ? 64 : 240) : 64 }}
      />
      <Container
        style={{
          paddingLeft: expanded ? (isTabletOrMobile ? 114 : 290) : 114,
          paddingRight: expanded ? (isTabletOrMobile ? 5 : 10) : 5,
        }}
      >
        {title && (
          <>
            <Row>
              <Col md={8}>
                <div className="page-title-banner">
                  <h1>{title}</h1>
                  <Button
                    onClick={handleClick}
                    className="button-new-volunteer"
                  >
                    Back
                  </Button>
                </div>
              </Col>
              <Col md={3}>
                <ProfileCard
                  id={state.profile?.id}
                  firstName={state.profile?.firstName}
                  lastName={state.profile?.lastName}
                  role={state.profile?.role}
                  pictureGuid={state.profile?.picture?.guidFile}
                />
              </Col>
            </Row>
          </>
        )}
        <Outlet />
      </Container>
      <Toasts />
      <Loading />
    </div>
  );
};

export default Layout;
